import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'fastestsmallesttextencoderdecoder';

// For tippy.js on IE11
if (!SVGElement.prototype.contains) {
  SVGElement.prototype.contains = HTMLDivElement.prototype.contains;
}

if (!window.crypto) {
  /* @ts-ignore */
  window.crypto = window.msCrypto;
}
